import React from 'react';
import {Box, Stack, Tooltip, Typography} from '@mui/material';
import CoverageBar from '../components/CoverageBar';

/**
 * Rich hover content for a coverage bar: 1-sentence explanation plus a short
 * FINTEL excerpt (owner decision: richer popover, not a plain text tooltip).
 */
function HoverContent({explanation, excerpt}) {
    return (
        <Stack spacing={1} sx={{p: 0.5, maxWidth: 360}}>
            {explanation && (
                <Typography variant="body2">{explanation}</Typography>
            )}
            {excerpt?.text && (
                <Box sx={{borderLeft: '2px solid', borderColor: 'divider', pl: 1}}>
                    {excerpt.reportTitle && (
                        <Typography variant="caption" fontWeight={700} display="block">
                            {excerpt.reportTitle}
                        </Typography>
                    )}
                    <Typography variant="caption" sx={{fontStyle: 'italic'}}>
                        “{excerpt.text}”
                    </Typography>
                </Box>
            )}
        </Stack>
    );
}

/**
 * Coverage bar whose hover shows the explanation popover (+ first excerpt).
 */
export default function CoverageHoverBar({value, explanation, excerpt = null, label, sx}) {
    const hasContent = Boolean(explanation || excerpt?.text);
    const bar = (
        <Box sx={{width: '100%', ...sx}}>
            <CoverageBar value={value} label={label}/>
        </Box>
    );
    if (!hasContent) {
        return bar;
    }
    return (
        <Tooltip
            arrow
            placement="top-start"
            title={<HoverContent explanation={explanation} excerpt={excerpt}/>}
            componentsProps={{
                tooltip: {
                    sx: {
                        bgcolor: 'background.paper',
                        color: 'text.primary',
                        boxShadow: 3,
                        border: '1px solid',
                        borderColor: 'divider',
                        '& .MuiTooltip-arrow': {color: 'background.paper'},
                    },
                },
            }}
        >
            {bar}
        </Tooltip>
    );
}
